/**
 * WebSocket Event Types
 *
 * Unified event type constants for the /realtime namespace.
 * These should be used instead of hardcoded strings for type safety.
 */

// ─────────────────────────────────────────────────────────────────────────────
// CHAT EVENTS
// ─────────────────────────────────────────────────────────────────────────────

export enum ChatEvent {
  // Client -> Server (actions)
  JOIN = 'chat:join',
  SUBSCRIBE_CONVERSATION = 'chat:subscribe-conversation',
  UNSUBSCRIBE_CONVERSATION = 'chat:unsubscribe-conversation',
  TYPING_START = 'chat:typing-start',
  TYPING_STOP = 'chat:typing-stop',
  MARK_READ = 'chat:mark-read',

  // Server -> Client (responses/broadcasts)
  JOINED = 'chat:joined',
  SUBSCRIBED = 'chat:subscribed',
  UNSUBSCRIBED = 'chat:unsubscribed',
  ACCESS_DENIED = 'chat:access-denied',
  NEW_MESSAGE = 'chat:new-message',
  MESSAGE_UPDATED = 'chat:message-updated',
  MESSAGE_DELETED = 'chat:message-deleted',
  MESSAGE_STATUS = 'chat:message-status',
  REACTION_ADDED = 'chat:reaction-added',
  REACTION_REMOVED = 'chat:reaction-removed',
  PARTICIPANT_ADDED = 'chat:participant-added',
  PARTICIPANT_REMOVED = 'chat:participant-removed',
  READ_RECEIPT = 'chat:read-receipt',
  USER_TYPING = 'chat:user-typing',
  USER_STOPPED_TYPING = 'chat:user-stopped-typing',
  CONVERSATION_CREATED = 'chat:conversation-created',
  CONVERSATION_UPDATED = 'chat:conversation-updated',
  ADDED_TO_CONVERSATION = 'chat:added-to-conversation',
  REMOVED_FROM_CONVERSATION = 'chat:removed-from-conversation',
}

// ─────────────────────────────────────────────────────────────────────────────
// TICKET EVENTS
// ─────────────────────────────────────────────────────────────────────────────

export enum TicketEvent {
  // Client -> Server (actions)
  SUBSCRIBE = 'ticket:subscribe',
  UNSUBSCRIBE = 'ticket:unsubscribe',
  SUBSCRIBE_QUEUE = 'ticket:subscribe-queue',
  SUBSCRIBE_ALL = 'ticket:subscribe-all',

  // Server -> Client (responses/broadcasts)
  SUBSCRIBED = 'ticket:subscribed',
  UNSUBSCRIBED = 'ticket:unsubscribed',
  QUEUE_SUBSCRIBED = 'ticket:queue-subscribed',
  ALL_SUBSCRIBED = 'ticket:all-subscribed',
  CREATED = 'ticket:created',
  UPDATED = 'ticket:updated',
  STATUS_CHANGED = 'ticket:status-changed',
  ASSIGNED = 'ticket:assigned',
  ASSIGNED_TO_YOU = 'ticket:assigned-to-you',
  UNASSIGNED = 'ticket:unassigned',
  UNASSIGNED_FROM_YOU = 'ticket:unassigned-from-you',
  PRIORITY_CHANGED = 'ticket:priority-changed',
  QUEUE_CHANGED = 'ticket:queue-changed',
  NOTE_ADDED = 'ticket:note-added',
  SLA_WARNING = 'ticket:sla-warning',
  SLA_BREACHED = 'ticket:sla-breached',
  DELETED = 'ticket:deleted',
}

// ─────────────────────────────────────────────────────────────────────────────
// CHANNEL EVENTS
// ─────────────────────────────────────────────────────────────────────────────

export enum ChannelEvent {
  // Client -> Server (actions)
  SUBSCRIBE = 'channel:subscribe',
  UNSUBSCRIBE = 'channel:unsubscribe',

  // Server -> Client (responses/broadcasts)
  SUBSCRIBED = 'channel:subscribed',
  UNSUBSCRIBED = 'channel:unsubscribed',
  STATUS_CHANGED = 'channel:status-changed',
  QR_UPDATED = 'channel:qr-updated',
}

// ─────────────────────────────────────────────────────────────────────────────
// CONTACT EVENTS
// ─────────────────────────────────────────────────────────────────────────────

export enum ContactEvent {
  // Server -> Client (broadcasts)
  UPDATED = 'contact:updated',
}

// ─────────────────────────────────────────────────────────────────────────────
// REACT ADMIN REALTIME
// ─────────────────────────────────────────────────────────────────────────────

export const RA_REALTIME_EVENT = 'ra-realtime';

// ─────────────────────────────────────────────────────────────────────────────
// CONNECTION EVENTS
// ─────────────────────────────────────────────────────────────────────────────

export enum ConnectionEvent {
  CONNECT = 'connect',
  DISCONNECT = 'disconnect',
  ERROR = 'error',
  CONNECT_ERROR = 'connect_error',
}

// ─────────────────────────────────────────────────────────────────────────────
// TICKET LIST REDUCER ACTION TYPES
// ─────────────────────────────────────────────────────────────────────────────

export enum TicketListAction {
  LOAD_TICKETS = 'LOAD_TICKETS',
  ADD_TICKET = 'ADD_TICKET',
  UPDATE_TICKET = 'UPDATE_TICKET',
  REMOVE_TICKET = 'REMOVE_TICKET',
}
